import isNil from 'lodash/isNil'
import { Price } from '@omnea-app/requests/price'
import { CurrencyCode } from 'utils/currency/getCurrencyCodes'
import { CoreDataCurrency } from 'utils/currency/hooks/useOrganisationCurrencies'
import { getDefaultFxRate } from 'utils/price/getDefaultFxRate'
import { Dictionary } from 'utils/utiltyTypes/utilityTypes'

type Input = {
  price: Price
  defaultCurrency?: CurrencyCode
  currenciesByCode?: Dictionary<CoreDataCurrency>
}

export const getAmountInDefaultCurrency = ({ price, defaultCurrency, currenciesByCode }: Input): number | undefined => {
  if (isNil(price.fxRate)) return

  if (price.currency === defaultCurrency) return price.amount

  const amount = price.amount

  const defaultFxRate = getDefaultFxRate({ currenciesByCode, defaultCurrency })

  return Number((amount / (defaultFxRate * price.fxRate)).toFixed(2))
}
